import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20",
  class: "coin_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm-.638-5.416V16h1.527v-1.463c.471-.08.89-.222 1.258-.424.436-.24.779-.551 1.027-.936.248-.394.372-.843.372-1.348 0-.642-.201-1.164-.603-1.566-.394-.402-.997-.689-1.81-.86l-1.399-.308c-.428-.094-.731-.214-.911-.36a.759.759 0 0 1-.257-.59c0-.325.141-.59.424-.795.29-.206.693-.308 1.206-.308.488 0 .941.072 1.36.218.42.137.788.342 1.104.616l.565-1.463c-.308-.308-.701-.543-1.18-.706a5.475 5.475 0 0 0-1.156-.277V4H9.362v1.462a3.796 3.796 0 0 0-1.27.412 2.893 2.893 0 0 0-1.053.975c-.248.402-.372.86-.372 1.373 0 .668.192 1.211.577 1.63.385.411.972.702 1.759.873l1.411.308c.445.103.758.227.937.372.18.146.27.334.27.565 0 .274-.129.51-.385.706-.257.188-.68.282-1.27.282a4.997 4.997 0 0 1-2.901-.91L6.5 13.612c.394.3.868.535 1.425.706.453.14.932.228 1.437.265Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }